var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPptICon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:file-pdf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2117_17621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 38,
    height: 46
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4144 4.16699H31.2477L41.6644 14.5837V43.7503C41.6644 44.3029 41.4449 44.8328 41.0542 45.2235C40.6635 45.6142 40.1336 45.8337 39.5811 45.8337H10.4144C9.86185 45.8337 9.33195 45.6142 8.94125 45.2235C8.55055 44.8328 8.33105 44.3029 8.33105 43.7503V6.25033C8.33105 5.69779 8.55055 5.16789 8.94125 4.77719C9.33195 4.38649 9.86185 4.16699 10.4144 4.16699Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.16667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.748 18.75H31.248V27.075L18.7564 27.0833L18.748 18.75Z",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.748 18.75V35.4167",
    stroke: "black",
    strokeWidth: 4.16667,
    strokeLinecap: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2117_17621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M-0.000976562 0H49.999V50H-0.000976562V0Z",
    fill: "#EB0730"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptICon);
export default __webpack_public_path__ + "static/media/pptICon.e20b3a36100a58573e86a1727308ce0f.svg";
export { ForwardRef as ReactComponent };